<template>
  <div class="divBG">
    <div class="divMsg">
      <div class="divMsg1">
        {{ pMsg }}
      </div>
      <div class="divMsg2">
        <p class="divMsgP divMsgP1" @click="aDo(false)">{{ pCancel }}</p>
        <p class="divMsgP divMsgP2" @click="aDo(true)">{{ pOk }}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default{
  name: 'MsgBox',
  props: {
    pMsg: {
      type: String,
      default: '操作成功'
    },
    p_bbAct: {
      type: Boolean,
      default: false
    },
    pCancel: {
      type: String,
      default: '取消'
    },
    pOk: {
      type: String,
      default: '确定'
    },
    pSecond: {
      type: Number,
      default: 2
    },
    aDo: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      bbShow: false
    }
  }
}
</script>
<style>/**scoped */
.divMsg{
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0;
  margin: 5% 25%;
  color:darkslategrey;
  background-color: white;
  border-radius: 3px;
  text-align: center;
  z-index: 45;
}
.divMsg1{
  font-size: 15px;
  padding: 20px 0;
}
.divMsg2{
  width: 100%;
  display: block;
  display: flex;
  flex-direction: row;
}
.divMsgP{
  width: 50%;
  height: 20px;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}
.divMsgP1{
  /**background-color: rgb(230, 227, 227); */
  border-bottom-left-radius: 3px;
}
.divMsgP2{
  /**background-color: rgb(105, 168, 105); */
  background-color: rgba(14, 14, 155, 0.726);
  color: white;
  border-bottom-right-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/comps/c2_info/06_msgBox.vue